import axios from 'axios';

class ColoresDataService {
  getAll() {
    return axios.get(`/api/colores`);
  }

  getSimple() {
    return axios.get(`/api/colores/search`);
  }

  get(id) {
    return axios.get(`/api/colores/${id}`);
  }

  create(data) {
    return axios.post(`/api/colores`, data);
  }

  update(id, data) {
    return axios.put(`/api/colores/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/colores/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/colores`);
  }
}

export default new ColoresDataService();